(function () {
/**
 * Triggers MV animation
 */ const $373485ec7925e9a5$var$mvTypingAnimation = function() {
    const spanElems = document.querySelectorAll(".lp__mv-heading span");
    const txts = [
        `Hello,‎`,
        `I am‎`,
        `Ton!`
    ];
    const speed = 70;
    var i = 0;
    var j = 0;
    var k = 0;
    function typeWriter(curr, index) {
        if (curr < txts[index].length) {
            spanElems[index].innerHTML += txts[index].charAt(curr);
            curr++;
            setTimeout(()=>typeWriter(curr, index), speed);
        }
    }
    // First span
    typeWriter(i, 0);
    // Second span
    setTimeout(()=>{
        typeWriter(j, 1);
    }, 490);
    // Third span
    setTimeout(()=>{
        typeWriter(k, 2);
    }, 840);
    // Circle 
    setTimeout(()=>{
        spanElems[2].classList.add("circle");
    }, 1200);
    // Highlight 
    const subheading = document.querySelector(".lp__mv-subheading span");
    setTimeout(()=>{
        subheading.classList.add("highlight");
    }, 1300);
};
var $373485ec7925e9a5$export$2e2bcd8739ae039 = $373485ec7925e9a5$var$mvTypingAnimation;


/**
 * Triggers animation on scroll
 */ const $cba07e96b5133753$var$scrollAnimation = function() {
    const targets = document.querySelectorAll("[data-scroll-animation]");
    // Intersection Observer OPTIONS
    const options = {
        root: null,
        threshold: 0
    };
    // ---------------- Functions --------------- //
    const addAnimationSpeed = function(el) {
        el.style.transition = "all 1s";
    };
    const removeAnimationSpeed = function(el) {
        setTimeout(()=>el.removeAttribute("style"), 1000);
    };
    // Intersection Observer CALLBACK
    const callback = function(entries) {
        const [entry] = entries;
        if (entry.isIntersecting) {
            addAnimationSpeed(entry.target);
            entry.target.classList.add("active");
            removeAnimationSpeed(entry.target);
        }
    };
    // Trigger animation if inside the screen.
    const displayAnimation = function() {
        targets.forEach((target)=>{
            const position = target.getBoundingClientRect().top;
            if (position >= 0 && position <= window.innerHeight) {
                addAnimationSpeed(target);
                target.classList.add("active");
                removeAnimationSpeed(target);
            }
        });
    };
    // ---------------- Events ------------------ //
    // Intersection Observer
    const animationObserver = new IntersectionObserver(callback, options);
    targets.forEach((target)=>animationObserver.observe(target));
    // Trigger animation on LOAD
    window.addEventListener("load", displayAnimation);
    // Trigger animation AFTER SCROLLING
    window.addEventListener("scrollend", displayAnimation);
};
var $cba07e96b5133753$export$2e2bcd8739ae039 = $cba07e96b5133753$var$scrollAnimation;


/**
 * Hamburger Menu on mobile.
 */ const $3ab1653c248eb4cb$var$hamburgerMenu = function() {
    const btn = document.querySelector(".header__hamburger");
    const nav = document.querySelector(".header__nav");
    const text = document.querySelector(".header__hamburger-text");
    const items = document.querySelectorAll(".js-nav-item");
    if (screen.width < 768) {
        const openMenu = function() {
            btn.classList.add("active");
            nav.classList.add("active");
            text.textContent = "CLOSE";
        };
        const closeMenu = function() {
            btn.classList.remove("active");
            nav.classList.remove("active");
            text.textContent = "MENU";
        };
        // Hamburger menu functionality.
        btn.addEventListener("click", function(e) {
            if (!btn.classList.contains("active")) openMenu();
            else closeMenu();
        });
        // Close menu when anchor is clicked.
        items.forEach((item)=>item.addEventListener("click", closeMenu));
    }
};
var $3ab1653c248eb4cb$export$2e2bcd8739ae039 = $3ab1653c248eb4cb$var$hamburgerMenu;


/**
 * Carousel functionality
 */ const $48b9a387ad08b0d6$var$seeMore = function() {
    const slides = document.querySelectorAll(".lp__background-item");
    // Create dynamic pagination.
    const pagination = document.querySelector(".lp__background-pagination");
    slides.forEach((_, i)=>{
        const bullet = i == slides.length - 1 ? "<span class='active'></span>" : "<span></span>";
        pagination.insertAdjacentHTML("afterbegin", bullet);
    });
    // For pagination bullet functionality
    const bullets = document.querySelectorAll(".lp__background-pagination span");
    const changeActive = function() {
        bullets.forEach((item, i)=>{
            if (i == curr) item.classList.add("active");
            else item.classList.remove("active");
        });
    };
    // Carousel Arrow Functionality
    const prevBtn = document.querySelector(".js-prev-btn");
    const nextBtn = document.querySelector(".js-next-btn");
    const list = document.querySelector(".lp__background-list");
    let curr = 0;
    nextBtn.addEventListener("click", function() {
        curr = curr < slides.length - 1 ? ++curr : 0;
        list.style.transform = `translateX(${100 * -curr}%)`;
        changeActive();
    });
    prevBtn.addEventListener("click", function() {
        curr = curr > 0 ? --curr : slides.length - 1;
        list.style.transform = `translateX(${100 * -curr}%)`;
        changeActive();
    });
};
var $48b9a387ad08b0d6$export$2e2bcd8739ae039 = $48b9a387ad08b0d6$var$seeMore;


/**
 * See more functionality
 */ const $96c35afed76ffaff$var$seeMore = function() {
    const btns = document.querySelectorAll(".js-accordion-btn");
    const panels = document.querySelectorAll(".js-accordion-panel");
    const containers = document.querySelectorAll(".lp__works-section");
    const more = "Show More";
    const less = "Show Less";
    btns.forEach((btn, i)=>{
        btn.addEventListener("click", function(e) {
            e.preventDefault();
            const panel = panels[i];
            const container = containers[i];
            if (panel?.classList.contains("show")) {
                container?.scrollIntoView({
                    behavior: "auto"
                });
                setTimeout(()=>{
                    panel?.classList.remove("show");
                    btn.textContent = more;
                }, 500);
            } else {
                panel.classList.add("show");
                btn.textContent = less;
            }
        });
    });
};
var $96c35afed76ffaff$export$2e2bcd8739ae039 = $96c35afed76ffaff$var$seeMore;


"use strict";
if (null) null.accept();
document.addEventListener("DOMContentLoaded", ()=>{
    (0, $373485ec7925e9a5$export$2e2bcd8739ae039)();
    (0, $cba07e96b5133753$export$2e2bcd8739ae039)();
    (0, $3ab1653c248eb4cb$export$2e2bcd8739ae039)();
    (0, $48b9a387ad08b0d6$export$2e2bcd8739ae039)();
    (0, $96c35afed76ffaff$export$2e2bcd8739ae039)();
}, false);

})();
//# sourceMappingURL=index.d98b2477.js.map
